import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";

import PropTypes from 'prop-types'

import NoProfilePhoto from "../../common/images-new/no-profile-pic.png"
import { apiUrl, serverUrl } from "../Helpers/Config";
import axios from "axios";

import { setUserPhoto } from "../../redux/actions/auth";

import { htmlToText, trimString, removeIframe, tokenAuthorize } from "../Helpers/Common";
import { Link } from "react-router-dom";
import { Card, TextGray } from "../../pages/Theme";

const PublicCardProfile = ({
    profilePic, username, email, program, aboutMe, userId, isGuest, programCategory,
}) => {
    const dispatch = useDispatch()

    const [profilePhoto, setProfilePhoto] = useState(profilePic);
    const [isEmailVisible, SetEmailVisible] = useState(false);
    useEffect(() => {
        setProfilePhoto(profilePic)
    }, [profilePic])

    useEffect(() => {
        axios.get(serverUrl.ProfileSettings).then(res => {
            if (res.status === 200) {
                SetEmailVisible(res?.data?.results?.display_email);
            }
        }).catch(err => {
            tokenAuthorize(err?.response?.status);
            console.log(err);
        })
    }, []);
    return (
        <Card className="flex flex-col w-72 px-4 -mt-32 md:-my-36 lg:-my-48 xl:-mt-64 mb-1 lg:mb-5 items-center rounded-xl">
            <div className="py-10 flex flex-col justify-center max-w-full overflow-hidden">
                <div
                    className="relative pb-3 flex justify-center p-2"
                >

                    <img
                        className="rounded-full w-36 h-36"
                        src={profilePhoto ? profilePhoto : NoProfilePhoto} alt="Profile pic"
                    />
                </div>

                <p className="text-xl font-bold pb-2 text-center break-words">{username}</p>
                {isEmailVisible && <TextGray className="text-base font-normal text-center break-words">{email}</TextGray>}
            </div>

            <div className="pb-3 w-full">
                <TextGray className="text-base font-normal">Programme:</TextGray>
                <p className="text-base font-bold break-words">{programCategory}</p>
                <hr className="my-5 w-60" />

                <p className="pb-4 text-base font-bold">About Me</p>
                {
                    (aboutMe && aboutMe.content) &&
                    <div className="flex flex-col flex-wrap pb-5 text-base text-justify font-normal container-multi">
                        <div className="text-viewer profile-width break-words break-words">
                            <div className="multiline-ellipsis6" dangerouslySetInnerHTML={{ __html: removeIframe(aboutMe.content) }} />
                            {/* {removeIframe(aboutMe.content)} */}
                        </div>
                        {/* <div>
                            { trimString(htmlToText(aboutMe.content), 200) }
                        </div> */}

                        <Link
                            to={isGuest ? `/public/${userId}${aboutMe.id}` : `/profile/${userId}/post/${aboutMe.id}`}
                            className="opacity-60 hover:opacity-80 cursor-pointer flex-1 text-right">
                            <TextGray> Read more </TextGray>
                        </Link>
                    </div>
                }
            </div>
        </Card>
    )
}

PublicCardProfile.propTypes = {
    profilePic: PropTypes.string,
    username: PropTypes.string,
    email: PropTypes.string,
    program: PropTypes.string
}
export default PublicCardProfile